import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { LeadOptOut } from "@school-sales-ai/shared";
import { api } from "@/lib/api";

/**
 * Whether this prospect's number asked to stop receiving bulk sends.
 *
 * Not gated on the plan — an opt-out is a person's request, and it stays visible
 * whether or not the school currently pays for the module that honours it.
 */
export function useLeadOptOut(leadId: string | undefined) {
  return useQuery({
    queryKey: ["lead-opt-out", leadId],
    queryFn: () => api.get<LeadOptOut>(`/crm/leads/${leadId ?? ""}/opt-out`),
    enabled: !!leadId,
    staleTime: 60_000,
  });
}

export function useSetLeadOptOut(leadId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (optedOut: boolean) =>
      api.put<LeadOptOut>(`/crm/leads/${leadId ?? ""}/opt-out`, { optedOut }),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: ["lead-opt-out", leadId] });
      toast.success(
        data.optedOut
          ? "Marcado: ya no recibirá envíos masivos."
          : "Listo: vuelve a recibir envíos masivos.",
      );
    },
    onError: (err: Error) => {
      toast.error(err.message);
    },
  });
}
